module.exports = vendor_1028da341226f1bb1b52;


//////////////////
// WEBPACK FOOTER
// external "vendor_1028da341226f1bb1b52"
// module id = 23
// module chunks = 0